<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalCauses"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title" style="font-weight: 600">CAUSES</div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div v-for="(item, id) in dataCause" :key="id">
              <div>{{ item.name }}</div>
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      :style="{
                        width: item.value == '0' ? '1%' : item.value + '%',
                      }"
                      aria-valuenow="30"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div class="col-2">{{ item.value }}</div>
              </div>

              <!-- <div>Unscheduled Maintenance</div>
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 90%"
                      aria-valuenow="90"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div class="col-2">9</div>
              </div>
              <div>Machine Failure</div>
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 70%"
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div class="col-2">7</div>
              </div>
              <div>Fuel Supply</div>
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 50%"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div class="col-2">5</div>
              </div>
              <div>Natural Events / Disasters</div>
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div class="col-2">100</div>
              </div>
              <div>Others</div>
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 20%"
                      aria-valuenow="20"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div class="col-2">2</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";

import GenerationService from "@/services/generation/generation";
const apiGeneration = GenerationService.build();
export default {
  props: ["showModal"],
  components: {
    IconSvg,
  },

  data() {
    return {
      dataCause: [],
      modal: null,
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalCauses);
  },

  methods: {
    async getDetailEffor() {
      const param = {
        instanceId: "consolidated",
      };
      const res = await apiGeneration.getDetailEffor(param);
      if (res && res.status == 200) {
        this.dataCause = res.data.data;
      }

      return [];
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  watch: {
    showModal() {
      if (this.showModal) {
        this.getDetailEffor();
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style scoped>
.custom-modal-width {
  max-width: 455px;
  width: 100%;
}
</style>
